import { OnboardingModeRadioGroup } from "@components/utils/Auth";
import { OnboardCallbackProps } from "@components/utils/Auth/types";
import { OnboardMode } from "@constants";
import { getStoredLoginMethod } from "@utils/credentials";
import { AuthToken, Button } from "kz-ui-sdk";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdChevronRight, MdPerson, MdPhoneAndroid } from "react-icons/md";
import LoginUP from "../LoginUP";
import RegisterUP from "../RegisterUP";

export interface OnboardUPProps extends OnboardCallbackProps {
  onForgotSecret?: () => void;
  onLoginSuccess?: (token: AuthToken) => void;
  onRegisterAndLoginSuccess?: (token: AuthToken) => void;
  onPostLoginCheckFailed?: () => void;
  onPostLoginCheckPassed?: () => void;
}

const OnboardUP = ({
  defaultMode = OnboardMode.LOGIN,
  onModeChange,
  onForgotSecret,
  onRegisterAndLoginSuccess,
  onLoginSuccess,
  onPostLoginCheckFailed,
  onPostLoginCheckPassed,
  deferUpdateToken,
}: OnboardUPProps) => {
  const { t } = useTranslation();
  const [mode, setMode] = useState<OnboardMode>(defaultMode);
  const [loginMethod, setLoginMethod] = useState<"phone" | "username">(getStoredLoginMethod());
  const [isAccountLocked, setIsAccountLocked] = useState(false);

  useEffect(() => {
    setMode(defaultMode);
  }, [defaultMode]);

  const handleAccountLocked = (isLocked: boolean) => {
    setIsAccountLocked(isLocked);
  };

  return (
    <>
      <OnboardingModeRadioGroup
        value={mode}
        onChange={(value) => {
          setMode(value);
          onModeChange?.(value);
        }}
      />
      <div className="mt-4 flex w-full flex-col">
        {mode === OnboardMode.LOGIN && (
          <>
            <Button
              variant="secondary"
              size="sm"
              onClick={() => setLoginMethod(loginMethod === "phone" ? "username" : "phone")}
              classes={{
                "root&": "!border-none !bg-transparent w-fit self-center !h-[16px]",
              }}
              iconPosition="right"
              className="mt-2"
              icon={<MdChevronRight className="text-base text-content-base" />}
              disabled={loginMethod === "username" && isAccountLocked}
            >
              <div className="flex items-center justify-center gap-x-1">
                {loginMethod === "phone" ? (
                  <MdPerson className="text-base text-content-base" />
                ) : (
                  <MdPhoneAndroid className="text-base text-content-base" />
                )}
                {loginMethod === "phone" ? t("login with username") : t("login with phone number")}
              </div>
            </Button>
            <div className="mt-6 flex flex-col items-center">
              <LoginUP
                defaultMethod={loginMethod}
                onAccountLocked={handleAccountLocked}
                isAccountLocked={isAccountLocked}
                onForgotSecret={onForgotSecret}
                onLoginSuccess={onLoginSuccess}
              />
            </div>
          </>
        )}

        {mode === OnboardMode.REGISTER && (
          <div className="flex animate-fade-in flex-col items-center">
            <RegisterUP
              onLoginSuccess={onRegisterAndLoginSuccess}
              onPostLoginCheckFailed={onPostLoginCheckFailed}
              onPostLoginCheckPassed={onPostLoginCheckPassed}
              deferUpdateToken={deferUpdateToken}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default OnboardUP;
